import PropTypes from 'prop-types';
import React, { Component } from 'react';
import utilities from './../../../utils/utilities';
import CountBox from '../../CountBox/CountBox.index';
import Spinner from './../../Spinner/Spinner';

export default function withCounter(CollectionComponent) {
    class Counter extends Component {
        static propTypes = {
            totalCount: PropTypes.number,
            filterCount: PropTypes.number,
            hasError: PropTypes.any,
            resetFilter: PropTypes.func
        }

        constructor(props) {
            super(props);

            this.resetFilter = this.resetFilter.bind(this);
        }

        resetFilter() {
            if (this.props.resetFilter) {
                this.props.resetFilter();
            }
        }

        render() {
            return <div>
                {!this.props.hasError &&
                    <Spinner isLoading={this.props.totalCount === null} tiny className={"count-box-spinner"}>
                        <CountBox totalCount={this.props.totalCount}
                                  partialCount={this.props.filterCount}
                                  showAll={this.resetFilter}/>
                    </Spinner>
                }
                <CollectionComponent {...this.props}
                                     ref={component => this.childRef = component}/>
            </div>
        }
    }

    Counter.displayName = `withCounter(${utilities.getDisplayName(CollectionComponent)})`;
    return Counter;
}


// WEBPACK FOOTER //
// ./src/scripts/reusable/LightTable/hoc/withCounter.jsx